module.exports = __webpack_public_path__ + "img/packages/l0.525571.png";